import {useNavigate, Link} from 'react-router-dom'
import vid from "../img/vid.gif"

function Page1(props) {
  let nav = useNavigate()
  const ok = () => {
    nav('/two')
  }

  return (
    <>
      <div className="page1">
        <img src={vid} width={"100%"} className="mtp" />
        <Link to={'/two'} className="nxt"></Link>
      </div>
    </>
  );
}

export default Page1;
